<template>
    <footer class="page-footer">
        <div class="page-bottom-bg"></div>
        <div class="page-footer__wrapper"><!--<div class="page-footer__wrapper">-->
            <span class="copy">Copyright by<img class="logo" src="../assets/images/logo.png" width="158" height="25" alt="AirEuropa Logo"> {{year}}</span>
            <span v-if="$route.name !== 'privacy'"><router-link :to="{ name : 'privacy' }">{{$t('privacy')}}</router-link></span>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "PageFooter",
        data(){
            return {
                year: '2019',
            }
        },
        beforeCreate() {
            this.year = new Date().getFullYear();
        },
    }
</script>

<style scoped>

</style>
